/*
 * assets/js/src/stats.js — počítadlo v pásu čísel (`.stats`).
 *
 * ---------------------------------------------------------------------
 * HODNOTA JE V HTML, SKRIPT JI JEN ROZPOHYBUJE
 * ---------------------------------------------------------------------
 * Návrh má v značce `<b data-count="16" data-suffix="+">0</b>`, tedy
 * NULU, a cílové číslo jen v atributu. Bez skriptu by na stránce zůstaly
 * čtyři nuly — nepravdivý údaj. Náš partial proto tiskne rovnou hotovou
 * hodnotu („16+") a tenhle modul si ji přečte, srazí na nulu a natočí
 * zpátky. Když skript neběží, číslo je správně od začátku.
 *
 * ---------------------------------------------------------------------
 * JEDNOU A AŽ NA OBRAZOVCE
 * ---------------------------------------------------------------------
 * Spouští se přes `IntersectionObserver` při vjezdu do výřezu a hned se
 * odpojuje — počítadlo, které se přehraje při každém odrolování nahoru
 * a dolů, je rušivé. Třída `.in` na pásu zapíná i animaci magentové
 * čárky, kterou má návrh v CSS.
 *
 * Při `prefers-reduced-motion: reduce` se NEPOČÍTÁ vůbec: hodnota
 * zůstane, jak je, a jen se přidá `.in`. Pohyb je tu ozdoba, ne obsah.
 *
 * Když prohlížeč `IntersectionObserver` nemá (pod naší podlahou to není,
 * ale záruka to není), pás se rovnou označí jako odkrytý.
 */

/** Rozebere „16+" na číslo a příponu. Bez čísla vrací `null`. */
function rozeber(text) {
	const m = String(text).match(/^(\D*)(\d[\d\s ]*)(.*)$/);
	if (!m) return null;
	const cislo = parseInt(m[2].replace(/[\s ]/g, ''), 10);
	if (!Number.isFinite(cislo)) return null;
	return { predpona: m[1], cislo, pripona: m[3] };
}

function natoc(el, cil, trvani) {
	const start = window.performance.now();
	const krok = (t) => {
		const podil = Math.min(1, (t - start) / trvani);
		// Zpomalení ke konci — číslo dojede, ne doskáče.
		const e = 1 - Math.pow(1 - podil, 3);
		el.textContent = cil.predpona + Math.round(cil.cislo * e) + cil.pripona;
		if (podil < 1) window.requestAnimationFrame(krok);
	};
	window.requestAnimationFrame(krok);
}

export function init() {
	const pasy = [...document.querySelectorAll('.stats')];
	if (!pasy.length) return 0;

	const klid = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	let pocet = 0;
	for (const pas of pasy) {
		if (pas.dataset.za2026Stats === '1') continue;
		pas.dataset.za2026Stats = '1';
		pocet += 1;

		const cisla = [...pas.querySelectorAll('b')]
			.map((el) => ({ el, cil: rozeber(el.textContent) }))
			.filter((x) => x.cil !== null);

		const spust = () => {
			pas.classList.add('in');
			if (klid) return;
			for (const { el, cil } of cisla) natoc(el, cil, 1100);
		};

		if (!window.IntersectionObserver) {
			spust();
			continue;
		}

		// Nula se ukáže až ve chvíli, kdy se opravdu začne počítat —
		// jinak by na stránce chvíli svítily nuly bez důvodu.
		const pozorovatel = new window.IntersectionObserver((zaznamy) => {
			for (const z of zaznamy) {
				if (!z.isIntersecting) continue;
				pozorovatel.disconnect();
				if (!klid) for (const { el, cil } of cisla) el.textContent = cil.predpona + '0' + cil.pripona;
				spust();
			}
		}, { threshold: 0.35 });
		pozorovatel.observe(pas);
	}
	return pocet;
}
